<main class="container">
  @if (client$ | async; as client) {
    <app-header
      [clients]="(clients$ | async)!"
      [gameType]="(gameType$ | async)!"
      [isMobile]="isMobile()"
      [userRole]="(userRole$ | async)!"
      [isLoading]="(isLoading$ | async)!"
      [isSidenavOpen]="isSidenavOpen()"
      (toggleMenu)="toggleSidenav()"
      (setGameType)="onSetGameType($event)"
      (setClient)="onSetClient($event)"
      (addClient)="onAddClient()">
    </app-header>
  }
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      [mode]="isMobile() ? 'over' : 'side'"
      class="sidenav"
      [class.menu-open]="isSidenavOpen()"
      [class.menu-close]="!isSidenavOpen()"
      [opened]="(sidenavShouldBeOpened$ | async)!"
      (closedStart)="onSidenavClosed()">
      @if (client$ | async; as client) {
        <div class="sidenav-content">
          <app-sidenav-menu
            [gameType]="(gameType$ | async)!"
            [isMobile]="isMobile()"
            [isSidenavOpen]="isSidenavOpen()"
            [userRole]="(userRole$ | async)!"
            (setGameType)="onSetGameType($event)">
          </app-sidenav-menu>
          <button
            (click)="logout()"
            class="logout-btn transparent-btn text-body-1">
            <img src="assets/menu-icons/Log-out.svg" alt="Logout" />
            @if (isSidenavOpen()) {
              {{ 'home.logout' | translate }}
            }
          </button>
        </div>
      }
    </mat-sidenav>

    <mat-sidenav-content [style.margin-left]="contentMargin$ | async">
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</main>
